import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function ProductPageHeader({
  actions,
  aside,
  children,
  controls,
  subtitle,
  title,
}) {
  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        px: { xs: 2, md: 4 },
        py: { xs: 3, md: 4 },
      })}
    >
      <Box
        sx={{
          alignItems: { xs: "stretch", lg: "flex-start" },
          display: "grid",
          gap: { xs: 2, lg: 3 },
          gridTemplateColumns: {
            xs: "1fr",
            lg: aside && actions
              ? "minmax(360px, 1fr) minmax(280px, 320px) auto"
              : actions
                ? "minmax(360px, 1fr) auto"
                : "1fr",
          },
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            component="h1"
            sx={{
              color: "text.primary",
              fontSize: { xs: 28, md: 32 },
              fontWeight: 800,
              letterSpacing: 0,
              lineHeight: "36px",
            }}
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                mt: 0.25,
              }}
            >
              {subtitle}
            </Typography>
          ) : null}

          {controls ? (
            <Box sx={{ mt: 1.5, width: "100%" }}>
              {controls}
            </Box>
          ) : null}

          {children}
        </Box>

        {aside ? (
          <Box
            sx={{
              alignSelf: { lg: "center" },
              display: "flex",
              justifyContent: { xs: "flex-start", lg: "center" },
            }}
          >
            {aside}
          </Box>
        ) : null}

        {actions ? (
          <Box
            sx={{
              alignSelf: { lg: "center" },
              display: "flex",
              justifyContent: { xs: "flex-start", lg: "flex-end" },
            }}
          >
            {actions}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
